/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AmendDrugAdministrationCommand } from '../models/AmendDrugAdministrationCommand';
import type { CreateDrugAdministrationCommand } from '../models/CreateDrugAdministrationCommand';
import type { DrugAdministrationDtoListResponse } from '../models/DrugAdministrationDtoListResponse';
import type { DrugAdministrationDtoResponse } from '../models/DrugAdministrationDtoResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class DrugAdministrationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param batchId
     * @returns DrugAdministrationDtoListResponse Success
     * @throws ApiError
     */
    public getApiDrugAdministrationsDrugAdministrations(
        batchId?: string,
    ): CancelablePromise<DrugAdministrationDtoListResponse> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/DrugAdministrations/DrugAdministrations',
            query: {
                'BatchId': batchId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugAdministrationDtoResponse Success
     * @throws ApiError
     */
    public postApiDrugAdministrationsCreateDrugAdministration(
        requestBody?: CreateDrugAdministrationCommand,
    ): CancelablePromise<DrugAdministrationDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DrugAdministrations/CreateDrugAdministration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns DrugAdministrationDtoResponse Success
     * @throws ApiError
     */
    public postApiDrugAdministrationsAmendDrugAdministration(
        requestBody?: AmendDrugAdministrationCommand,
    ): CancelablePromise<DrugAdministrationDtoResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/DrugAdministrations/AmendDrugAdministration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Server Error`,
            },
        });
    }
}
